import styled from 'styled-components';

import { Badge } from 'components/offer-badges/badge';

export const Content = styled.div`
  padding: 1.25rem 1.5rem;
`;

export const OptionHeader = styled.h4`
  margin: 0;
`;

export const SelectionContainer = styled.div`
  margin-right: 1rem;
  cursor: pointer;
  position: relative;

  div[type='radio'] {
    top: 5px;
  }
`;

export const StyledBadge = styled(Badge)`
  margin-left: 5px;
  letter-spacing: 1px;
  background: ${Styles.color.grey.five};
  color: ${Styles.color.grey.eight};
  padding: 2px 10px;
`;
